<template>
    <div>
        <b-navbar toggleable="lg" type="light" class="header" id="navbar-header">
            <b-navbar-brand>
                <img :src="require('../../assets/foove-logo.svg?v=1')" alt="Logo">
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
<!--                    <b-nav-item to="/">-->
<!--                        <b-icon icon="house"></b-icon>-->
<!--                    </b-nav-item>-->
                    <b-nav-item to="/">Essensausgabe</b-nav-item>
                    <b-nav-item to="/history">Verlauf</b-nav-item>
                    <b-nav-item to="/kiosk">Kiosk</b-nav-item>
                    <b-nav-item @click="$bvModal.show('order-preview-modal')">Essenstatistik</b-nav-item>
                    <!--                <b-nav-item to="/catering">Bestellung Zentrale</b-nav-item>-->
                </b-navbar-nav>

                <b-navbar-nav class="ml-auto">
                    <b-col align-self="center">
                        <b-row>
                            <span class="stat-color-text">Vorbestellungen: <strong class="ml-1 mr-1">{{ allPreOrders() }} / {{ pickedPreOrders() }}</strong></span>
                        </b-row>
                        <b-row>
                            <span class="stat-color-text">Spontanessen: <strong class="ml-1 mr-1">{{ allVoucherOrders() }} / {{ pickedVoucherOrders() }}</strong></span>
                        </b-row>
                    </b-col>
                </b-navbar-nav>

                <b-navbar-nav class="ml-5">
                    <b-col align-self="center">
                        <b-row>
                        <span class="stat-color-text">Gesamt: <strong
                            class="ml-1 mr-3">{{ pickedVoucherOrders() + pickedPreOrders() }}</strong></span>
                            <b-icon icon="info-circle-fill" scale="1.5" id="show-order-per-location"
                                    class="mt-1"
                                    variant="info"
                                    style="color: #3E4462 !important;"
                                    @click="showOrderPerLocation = !showOrderPerLocation"></b-icon>

                            <b-popover ref="popover" target="show-order-per-location"
                                       :show.sync="showOrderPerLocation" :triggers="['hover']"
                                       placement="bottom" custom-class="custom-width">
                                <template #title></template>
                                <div v-for="(location, index) in auth.userLocations" :key="index">
                            <span class="text-success"><strong class="stat-location-color">{{
                                    location.name
                                }}:</strong></span><br>
                                    <div class="d-inline">
                                        <span>
                                            Vorbestellungen: <strong>{{ allPreOrders(location.id) }} / {{ pickedPreOrders(location.id) }}</strong>
                                        </span>
                                                <span>
                                            | Essensausgabe: <strong>{{ allVoucherOrders(location.id) }} / {{ pickedVoucherOrders(location.id) }}</strong>
                                        </span>
                                                <span>
                                            | Gesamt: <strong>{{ pickedVoucherOrders(location.id) + pickedPreOrders(location.id) }}</strong>
                                        </span>
                                    </div>
                                </div>
                            </b-popover>
                        </b-row>
                    </b-col>
                </b-navbar-nav>

                <b-navbar-nav class="ml-auto" v-if="userName()">
                    <b-nav-item href="javascript:void(0)" @click="showLogoutModal">
                        <img :src="require('../../assets/logout.png')" alt="Ausloggen"
                             title="Ausloggen">
                    </b-nav-item>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
        <b-modal id="confirmation-modal" size="m">
            Möchten Sie sich abmelden?
            <template #modal-footer>
                <button type="button" class="btn btn-warning" @click="logout">Ja</button>
                <button type="button" class="btn btn-secondary" @click="hideModal">Nein</button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import {mapGetters, mapState}                                                 from 'vuex';
import {allPreOrders, allVoucherOrders, pickedPreOrders, pickedVoucherOrders} from "../../utils/helpers";

export default {
    name: 'CoreHeader',
    data() {
        return {
            showOrderPerLocation: false,
        }
    },
    computed: {
        ...mapState(['auth']),
        ...mapGetters(['limitOrders', 'voucherLimits']),
    },
    methods:  {
        hideModal() {
            this.$bvModal.hide('confirmation-modal')
        },
        pickedPreOrders(locationId = false) {
            return pickedPreOrders(this.limitOrders, locationId)
        },
        allPreOrders(locationId = false) {
            return allPreOrders(this.limitOrders, locationId)
        },
        allVoucherOrders(locationId = false) {
            return allVoucherOrders(this.voucherLimits, this.limitOrders, locationId)
        },
        pickedVoucherOrders(locationId = false) {
            return pickedVoucherOrders(this.limitOrders, locationId)
        },
        showLogoutModal() {
            this.$bvModal.show('confirmation-modal')
        },
        logout() {
            window.localStorage.removeItem('ACCESS_TOKEN');
            window.localStorage.removeItem('USER_NAME');
            this.$store.dispatch('setAuth', null);
            this.$store.dispatch('setLocations', []);
            this.$store.dispatch('setLimitOrders', false);
            this.$router.push({name: 'login'});
        },
        userName() {
            return window.localStorage.getItem('USER_NAME');
        },
    },
}
</script>

<style scoped lang="scss">
@import "../../assets/styles/custom_theme";

.header {
    border-bottom: 2px solid $accent-color;
}

img {
    height: 30px;
    width: auto;
    margin-top: -13px;
}

.search {
    width: 100%;
}

> > > .search .autocomplete-input {
    border-radius: 6px;
}

.navbar-light .navbar-nav .nav-link {
    color: $base-color;
}

.navbar-light .navbar-nav .nav-link.router-link-exact-active {
    color: $accent-color;
}

.stat-color-text {
    color: rgba(0, 0, 0, 0.5);
}

.color-accent {
    color: $accent-color;
}

.stat-location-color {
    color: $accent-color;
}

div.popover.custom-width {
    max-width: 26rem !important;
    width: 26rem !important;
}

</style>
